import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '../assets/svg/cake.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "square-push" }, null, -1)
const _hoisted_2 = { class: "column ion-padding absolute" }
const _hoisted_3 = {
  key: 1,
  src: _imports_0
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, { class: "ion-padding" }, {
    default: _withCtx(() => [
      (_ctx.categories.length > 0)
        ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXl: "8",
                offsetXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                        return (_openBlock(), _createBlock(_component_ion_col, {
                          sizeXs: "6",
                          sizeSm: "4",
                          sizeMd: "3",
                          key: cat.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              color: cat.category_bg_colour,
                              expand: "block",
                              class: "unset-text ion-align-items-center block-children",
                              onClick: ($event: any) => (_ctx.setCategoryFilter(cat.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_1,
                                _createVNode("div", _hoisted_2, [
                                  (cat.category_image)
                                    ? (_openBlock(), _createBlock("img", {
                                        key: 0,
                                        src: `${_ctx.store.state.apiUrl}/storage/${cat.category_image}`
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (!cat.category_image)
                                    ? (_openBlock(), _createBlock("img", _hoisted_3))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_text, null, {
                                    default: _withCtx(() => [
                                      _createVNode("h2", null, _toDisplayString(cat.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["color", "onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}